import React, { useState } from 'react';
import RuleBreakingFeed from './RuleBreakingFeed';
import RuleBreakingCalendar from './RuleBreakingCalendar';
import LockedWidgetOverlay from '../../../components/common/LockedWidgetOverlay';

const RuleBreakingPanel = ({ feedData = [], calendarData = [], isBasicOrAbove, isProOrAbove }) => {
  const [view, setView] = useState('feed');

  if (!isBasicOrAbove) {
    return (
      <LockedWidgetOverlay
        title="Rule Violations"
        benefit="See a detailed feed and calendar of when you broke trading rules and the impact on each trade"
        requiredPlan="basic"
      />
    );
  }

  return (
    <div>
      {/* Toggle header */}
      <div className="flex items-center justify-between mb-3">
        <span className="text-xs font-semibold uppercase tracking-widest text-muted-foreground">
          Rule Violations
        </span>
        <div className="flex items-center gap-1 bg-muted rounded-md p-0.5">
          <button
            onClick={() => setView('feed')}
            className={`px-3 py-1 text-xs font-medium rounded transition-colors ${
              view === 'feed'
                ? 'bg-primary text-primary-foreground'
                : 'text-muted-foreground hover:text-foreground'
            }`}
          >
            Feed
          </button>
          <button
            onClick={() => setView('calendar')}
            className={`px-3 py-1 text-xs font-medium rounded transition-colors ${
              view === 'calendar'
                ? 'bg-primary text-primary-foreground'
                : 'text-muted-foreground hover:text-foreground'
            }`}
          >
            Calendar
          </button>
        </div>
      </div>

      {view === 'feed' && <RuleBreakingFeed data={feedData} />}

      {view === 'calendar' && (
        isProOrAbove ? (
          <RuleBreakingCalendar data={calendarData} />
        ) : (
          <LockedWidgetOverlay
            title="Rule Breaking Calendar"
            benefit="Visualize your rule violations across time to identify triggers and problem days"
            fullWidth
            requiredPlan="pro"
          />
        )
      )}
    </div>
  );
};

export default RuleBreakingPanel;
